<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

export default {
  page: {
    title: "Fees SMS",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Custom SMS",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Bulk SMS",
          href: "/bulk-sms",
        },
        {
          text: "Custom SMS",
          active: true,
        },
      ],
      data: {
        class: "",
        message: "",
        course: "",
      },
      pageError: {
        classError: false,
      },
    };
  },

  computed: {
    ...mapGetters("classes", [
      "AllClasses",
      "AllStreams",
      "AllCourses",
      "CustomClasses",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("bulksms", [
      "getMarksResponse",
      "getMarksSMS",
      "getSmsCalc",
      "getsmsBalance",
      "SaveStatus",
    ]),
  },
  watch: {
    // getSmsCalc() {
    // },
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      SubmitOthersSMS: "bulksms/submitOthersSMS",
      SubmitMarksSMS: "bulksms/submitMarksSMS",
      CustSmsCalc: "bulksms/examSmsCalc",
      FetchSmsBalance: "bulksms/fetchSmsBalance",
      FetchCourses: "classes/fetchCourses",
      FetchCustomClasses: "classes/fetchCustomClasses",
    }),
    submitOthersSms() {
      // this.resetError();
      this.data.class != "" && this.data.message != "" && this.data.course != ""
        ? this.SubmitOthersSMS(this.data)
        : null;
    },

    calculateSms() {
      this.data.term != "" ? this.CustSmsCalc(this.data) : null;
    },

    assignSMS() {
      this.data.message = this.getCurrentUser.school.name + ".";
    },

    fetchClasses() {
      const selectedCourse = { course: this.data.course };
      this.FetchCustomClasses(selectedCourse);
    },

    resetError() {
      this.data.class.length
        ? (this.pageError.classError = false)
        : (this.pageError.classError = true);
    },
  },
  created() {
    this.FetchSmsBalance();
    this.assignSMS();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row d-flex"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('send_custom_sms')
        )
      "
    >
      <div class="col-md-11 mx-auto">
        <div class="card row">
          <form @submit.prevent="submitOthersSms">
            <div class="card-body col-md-12 mx-auto row">
              <div class="row col-md-6">
                <div class="form-group col-md-12">
                  <label>Courses <small class="text-danger">*</small></label>
                  <div class="input-group mb-3">
                    <select
                      required
                      class="form-control"
                      v-model="data.course"
                      @change="calculateSms(), fetchClasses()"
                    >
                      <option value="" disabled selected>Select Course</option>
                      <option
                        v-for="(course, index) in AllCourses"
                        :value="course.id"
                        :key="index"
                        >{{ course.name }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="form-group col-md-12 mb-3">
                  <label>Level <small class="text-danger">*</small></label>
                  <div class="input-group">
                    <select
                      required
                      class="form-control"
                      v-model="data.class"
                      @change="calculateSms()"
                    >
                      <option value="" disabled selected>Select Level</option>
                      <option
                        v-for="(level, index) in CustomClasses"
                        :value="level.id"
                        :key="index"
                        >{{ level.name }}</option
                      >
                    </select>
                  </div>
                </div>

                <div class="form-group col-md-12 mb-3">
                  <label>Custom Message</label>
                  <textarea
                    v-model="data.message"
                    class="form-control mb-2"
                    rows="5"
                    required
                    @keypress="resetError()"
                    placeholder="Enter the SMS to parents"
                  ></textarea>
                  <p>
                    <span class="text-success">
                      <b>{{ data.message.length }}</b>
                      Characters | Size:
                      <b>{{ Math.ceil(data.message.length / 159) }} SMS</b>
                    </span>
                    <small class="text-primary ml-2">
                      {{ " " }}(1 SMS = 159 Characters)</small
                    >
                  </p>
                </div>
                <div class="form-group col-md-12 mt-3">
                  <div
                    class="alert alert-danger"
                    role="alert"
                    v-if="
                      getsmsBalance.deposit -
                        getsmsBalance.used -
                        getSmsCalc.total_std *
                          Math.ceil(data.message.length / 159) <
                        0
                    "
                  >
                    <h5 class="card-title text-danger">
                      <i class="fa fa-exclamation" aria-hidden="true"></i>
                      Caution
                      <i class="fa fa-exclamation" aria-hidden="true"></i>
                    </h5>
                    <span>
                      You have Less SMS Balance, Please subscribe for more SMS
                      before you continue.
                      <br />
                      <br />
                      <router-link
                        to="/bulk-sms/settings"
                        role="button"
                        class="btn btn-sm btn-primary"
                      >
                        <i class="fa fa-circle-check"></i>
                        Click to Subscribe
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row col-md-6">
                <div class="col-lg-12 col-md-12">
                  <div class="text-primary mb-2">
                    <strong>Total Students/Messages</strong>
                  </div>
                  <div class="text-muted">
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Total Students </strong
                      ><span class="card-title">{{
                        getSmsCalc.total_std ? getSmsCalc.total_std : "0"
                      }}</span>
                    </p>
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>SMS Size</strong>
                      <span class="card-title">
                        {{ Math.ceil(data.message.length / 159) }}
                      </span>
                    </p>
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Total SMS/Messages</strong>
                      <span class="card-title">
                        {{
                          getSmsCalc.total_std
                            ? getSmsCalc.total_std *
                              Math.ceil(data.message.length / 159)
                            : "0"
                        }}
                      </span>
                    </p>
                  </div>
                  <div class="text-muted">
                    <p class="mb-1 text-success">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Total SMS/Messages Balance</strong> |
                      <span class="card-title">{{
                        getsmsBalance.deposit - getsmsBalance.used
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="col-md-12">
                  <button
                    v-if="SaveStatus"
                    type="button"
                    disabled
                    class="btn btn-primary btn-sm float-end"
                  >
                    <b-spinner
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                    Please Wait...
                  </button>
                  <button
                    v-else-if="
                      getsmsBalance.deposit -
                        getsmsBalance.used -
                        getSmsCalc.total_std *
                          Math.ceil(data.message.length / 159) <
                        0
                    "
                    type="button"
                    disabled
                    class="btn btn-primary btn-sm float-end"
                  >
                    Send Message(s)
                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                  </button>
                  <button
                    v-else
                    type="submit"
                    class="btn btn-outline-primary btn-sm float-end"
                  >
                    Send Message(s)
                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
